import styled from 'styled-components'

import { ArrowTriangleDownIcon, ArrowTriangleUpIcon } from '@root/shared/ui-kit'

import { Trend } from '../model'

import type { ClassNameProps } from '@root/shared/react'

type Props = {
  trend: Trend.Trend
  size?: number
} & ClassNameProps

export const TrendTriangle: React.FC<Props> = ({
  trend,
  className,
  size = 12,
}) => {
  if (trend === Trend.Neutral) {
    return undefined
  }

  const Icon = trend === Trend.Down ? DownIcon : UpIcon

  return <Icon className={className} size={size} />
}

const DownIcon = styled(ArrowTriangleDownIcon)`
  --downtrend-color: var(--down-9);
  color: var(--downtrend-color);
`

const UpIcon = styled(ArrowTriangleUpIcon)`
  --uptrend-color: var(--up-9);
  color: var(--uptrend-color);
`
